import { AdminRoutePathsEnum } from '@/modules/admin/routes/adminRouteConfig.types'
import { AdvisorUsersRoutePathsEnum } from '@/modules/advisors/users/routes/advisorsUsersRouteConfig.types'
import { CommonRoutePathsEnum } from '@/modules/common/routes/commonRouteConfig.types'
import { DashboardRoutePathsEnum } from '@/modules/dashboard/routes/dashboardRouteConfig.types'
import { EmployerRoutePathsEnum } from '@/modules/employer/routes/employerRouteConfig.types'

import { role as Roles, type UserData } from '@/__generated__/requests'

export function getUserDefaultPath(user: UserData, currentRole: Roles | null) {
  if (!currentRole) {
    return CommonRoutePathsEnum.REDIRECTED_TO_NOT_FOUND
  }

  if (!user.roles?.includes(currentRole)) {
    return CommonRoutePathsEnum.REDIRECTED_TO_NOT_FOUND
  }

  switch (currentRole) {
    case Roles.ADVISOR:
      return AdvisorUsersRoutePathsEnum.USERS
    case Roles.EMPLOYEE:
      return DashboardRoutePathsEnum.DASHBOARD
    case Roles.EMPLOYER:
      return EmployerRoutePathsEnum.DASHBOARD
    case Roles.ADMIN:
      return AdminRoutePathsEnum.DASHBOARD
    default:
      return CommonRoutePathsEnum.REDIRECTED_TO_NOT_FOUND
  }
}
